import { Extension } from '@tiptap/core';

const OverrideEnterKey = Extension.create({
  name: 'submitOnEnter',

  addOptions() {
    return {
      onEnterPress: () => {},
    };
  },

  addKeyboardShortcuts() {
    return {
      Enter: () => {
        this.options.onEnterPress();
        return true; // prevent default behavior
      },
    };
  },
});

export default OverrideEnterKey;
